import $foreign from "./foreign.cjs";
var clear = $foreign.clear;
var error = $foreign.error;
var info = $foreign.info;
var log = $foreign.log;
var time = $foreign.time;
var timeEnd = $foreign.timeEnd;
var timeLog = $foreign.timeLog;
var warn = $foreign.warn;
export { clear, error, info, log, time, timeEnd, timeLog, warn };
